import React, { Component } from "react";
import axios from "axios";
import { routes } from "../General";
import moment from "moment";
import { siniestroIsLiquidado } from "../../coms/BlkGenerales";

export class Contratante extends Component {
    constructor(props) {
        super(...arguments);
        this.state = {
            plan: "",
            deducibles: {},
        };
    }

    componentDidMount() {
        this.getNmPlan();
        this.getValDeducible();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { cdUbicacion } = this.props.siniestro;
        let { cdUbicacionOld } = prevProps.siniestro;

        if (cdUbicacion && cdUbicacionOld && cdUbicacion !== cdUbicacionOld) {
            this.getNmPlan();
        }
    }

    getNmPlan = () => {
        axios
            .get(routes.api + "/ubicacion/plan", {
                params: {
                    cdCompania: this.props.siniestro.cdCompania,
                    cdUbicacion: this.props.siniestro.cdUbicacion,
                },
            })
            .then(resp => {
                this.setState({ plan: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getValDeducible = () => {
        axios
            .get(routes.api + "/siniestro/valdeducible", {
                params: {
                    cdCompania: this.props.siniestro.cdCompania,
                    cdIncSiniestro: this.props.siniestro.cdIncSiniestro,
                },
            })
            .then(resp => {
                this.setState({ deducibles: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    imprimir = () => {
        axios
            .get(routes.api + "/siniestros-vam/imprimir", {
                params: {
                    cdIncSiniestro: this.props.siniestro.cdIncSiniestro
                        ? this.props.siniestro.cdIncSiniestro
                        : this.props.siniestro.numSiniestro,
                    cdReclamo: this.props.siniestro.cdReclamo,
                    cdCompania: this.props.siniestro.cdCompania,
                },
                responseType: "arraybuffer",
            })
            .then(response => {
                let blob = new Blob([response.data], { type: "application/pdf" });
                let url = window.URL.createObjectURL(blob);
                window.open(url);
                this.props.alert.show_info("Generado con éxito");
            })
            .catch(error => {
                this.props.alert.handle_error("Error al generar PDF. Consulte con el administrador del sistema.");
            });
    };

    fechaFormato = (fecha, format = "DD/MMM/YYYY") => {
        return fecha ? moment(fecha).locale("moment/locale/es").format(format) : "";
    };

    render() {
        let { siniestro, cliente, diasExtra } = this.props;
        let dias2 = siniestro.dias2 ? siniestro.dias2 : 0;
        let dias = siniestro.dias ? siniestro.dias : 0;
        let dias3 = (diasExtra || {}).dias;
        let fechaEstimada = (diasExtra || {}).dueDate;

        let liquidacion = this.props.liquidacion;
        let obs = "";
        if (liquidacion && liquidacion.length > 0) {
            obs = liquidacion[0].obsPago;
        }

        return (
            <div className="col-lg-3 bg-primary pd-lateral pt-2 pt-md-5">
                <table className="m-auto text-left fs12 line-height-normal">
                    <tbody>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Contratante:</td>
                        </tr>
                        <tr>
                            <td>{cliente.titular}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Póliza:</td>
                        </tr>
                        <tr>
                            <td> {siniestro.poliza}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Plan:</td>
                        </tr>
                        <tr>
                            <td> {this.state.plan}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Aseguradora:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.nmAseguradora}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Titular:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.titular}</td>
                        </tr>

                        <tr>
                            <td className=" font-weight-bolder text-primary">Paciente:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.dscObjeto}</td>
                        </tr>

                        <tr>
                            <td className=" font-weight-bolder text-primary">Diagnostico:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.nmIncapacidad}</td>
                        </tr>

                        <tr>
                            <td className=" font-weight-bolder text-primary">Val Incurrido:</td>
                        </tr>
                        <tr>
                            <td>${siniestro.valIncurrido}</td>
                        </tr>
                        {siniestroIsLiquidado(siniestro) && (
                            <>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Valor Liquidado:</td>
                                </tr>
                                <tr>
                                    <td>${this.state.deducibles.liquidacion}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Deducible Aplicado:</td>
                                </tr>
                                <tr>
                                    <td>${this.state.deducibles.deducible} </td>
                                </tr>
                            </>
                        )}
                        <tr>
                            {diasExtra ? (
                                <td className=" font-weight-bolder text-primary">
                                    No. de días liquidado/transcurridos
                                </td>
                            ) : (
                                <td className=" font-weight-bolder text-primary">Días Transcurridos</td>
                            )}
                        </tr>
                        <tr>
                            <td> {dias3 ? dias3 : siniestro.estado === "X" ? dias2 : dias}</td>
                        </tr>

                        <tr>
                            <td className=" font-weight-bolder text-primary">Tipo:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.tpSiniestro}</td>
                        </tr>
                        {fechaEstimada && (
                            <>
                                <tr>
                                    <td className=" font-weight-bolder text-primary">Fecha estimada respuesta:</td>
                                </tr>
                                <tr>
                                    <td className={`${diasExtra.fechaEstimadaOld ? "text-danger" : ""}`}>
                                        {this.fechaFormato(fechaEstimada)}
                                    </td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td className=" font-weight-bolder text-primary">Observaciones:</td>
                        </tr>
                        <tr>
                            <td>{obs}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
